export enum Validation {
  maxInt = 2147483647,
}
